import React, { Component } from 'react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import './CnvRead.scss'
import { inject, observer } from 'mobx-react'
import {Table} from "antd"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"

@inject('auth') @observer
export default class CnvReadDetail extends Component {
   
    constructor(props){
        super(props)
    }
    render() {
        let {
            closeModal,
        } = this.props
       
        let { gene_annos } =this.props
        var dataSource=[...gene_annos]
        for(let i=0;i<dataSource.length;i++){
            dataSource[i].genes_detail2=[...dataSource[i].genes_detail]
        }
        const columns = [
                { title: 'gene',dataIndex: 'gene',width:50,},
                { title:'symbol',dataIndex: 'symbol',width:50,},
                { title:'omim.phenotype_id',dataIndex: 'omim.phenotype_id',width:50,},
                { title:'omim.phenotype',dataIndex: 'omim.phenotype',
                render: (text) => {
            
                    return (
                      <MaterialTip
                        overlayClassName="ellipsis-tip"
                        title={text}
                      >
                        <div className="sample-name ellipsis" >
                              {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
                        </div>
                      </MaterialTip>
                    )
                  }
                },
                { title:'decipher_hi_index.hi_index',dataIndex: 'decipher_hi_index.hi_index',width:50,
                    sorter: (a, b) => a.decipher_hi_index.hi_index - b.decipher_hi_index.hi_index,
                },
                { title:'gnomad_plof.pli',dataIndex: 'gnomad_plof.pli',width:50,
                    sorter: (a, b) => a.gnomad_plof.pli - b.gnomad_plof.pli,
                },
                { title:'gnomad_plof.oe_lof_upper',dataIndex: 'gnomad_plof.oe_lof_upper',width:50,
                    sorter: (a, b) => a.gnomad_plof.oe_lof_upper - b.gnomad_plof.oe_lof_upper,
                },
                { title:'omim.omim_id',dataIndex: 'omim.omim_id',width:50},
                { title:'omim.inheritance',dataIndex: 'omim.inheritance',width:50,
                    // sorter: (a, b) => (a.gnomad_plof.oe_lof_upper).localeCompare(b.gnomad_plof.oe_lof_upper),
                },
                { title:'genes_detail',dataIndex: 'genes_detail2',width:100,
                    render: (text) => {
                        var str=''
                        for(let i=0;i<text.length;i++){
                            str+=text[i].trans_id+';'
                            text[i].detail2=[...text[i].detail]
                            for(let n=0;n<text[i].detail2.length;n++){
                                str+=text[i].detail2[n]
                            }
                            str+='<br></br>'
                        }
                        return <div dangerouslySetInnerHTML={{__html:str}}/>
                       
                    }
                },
                { title:'clingen.date_last',dataIndex: 'clingen.date_last',width:50},
                { title:'clingen.hi_score',dataIndex: 'clingen.hi_score',width:50,
                    sorter: (a, b) => a.clingen.hi_score - b.clingen.hi_score,
                },
                { title:'clingen.hi_pmid',dataIndex: 'clingen.hi_pmid',width:50},
                { title:'clingen.ts_score',dataIndex: 'clingen.ts_score',width:50,
                    sorter: (a, b) => a.clingen.ts_score - b.clingen.ts_score,
                },
                { title:'clingen.ts_pmid',dataIndex: 'clingen.ts_pmid',width:50},
                { title:'imprint.status',dataIndex: 'imprint.status',width:50},
                { title:'imprint.expressed_allele',dataIndex: 'imprint.expressed_allele',width:50}
            ]
        return (
            <MaterialModal
                wrapClassName='push-modal-wrap'
                draggable={true}
                className="push-modal"
                title="基因"
                visible={true}
                width={1000}
                mask={false}
                action={() => closeModal()}
            > 
                <img
                className="pgx-modal-close"
                src={closeIcon}
                alt="关闭对话框"
                onClick={() => {
                    closeModal()
                }}
                />
            <div className="detail-card">
                <h3 className="border-left-primary detail-card-title" >每行代表一个基因</h3>
                <Table 
                    rowKey={record =>record.gene}
                    columns={columns} 
                    dataSource={dataSource} 
                    bordered
                    pagination={false}
                    // scroll={{ x: 900, y: 300 }}
                    scroll={{ y: 300 }}
                />
               
            </div>
            </MaterialModal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/CnvReadDetail/CnvRead.js